












import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import Carriers from './index';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-carriers-compose';
export default defineComponent({
  name,
  components: {
    TtamCarriers: Carriers.TtamCarriers,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const _carriers = computed({
      get: () => adgroupData.value.carriers,
      set: val => {
        emit('change', val);
        emit('input', val);
      },
    });
    Carriers.useDataSource();
    const { operatorsOptions } = Carriers.useOperatorOptions({
      adgroupData,
    });

    const iconHoverTrack = () => trackEvent('adgroup_operator_carrier_tips_hover');
    return {
      name,
      _carriers,
      operatorsOptions,
      iconHoverTrack,
    };
  },
});
